<h1 class="error-message">
  {{ 'auth.session_expired_dialog.error_message' | translate }}
</h1>
<span class="close-message">{{
  'auth.session_expired_dialog.close_message' | translate
}}</span>
<rd-shared-button
  class="ok-button-wrapper"
  [buttonClass]="'ok-button'"
  [buttonContent]="okButtonContent"
  [buttonTheme]="'primary'"
  (clickFn)="closeDialog()">
  <ng-template #okButtonContent>
    <span>{{ 'auth.session_expired_dialog.ok_button' | translate }}</span>
  </ng-template>
</rd-shared-button>
